import type { LocaleSetting, LocaleType } from '/#/config'

import { defineStore } from 'pinia'
import { store } from '/@/store'
import { ref, computed } from 'vue'

import { LOCALE_KEY } from '/@/enums/cacheEnum'
import { createLocalStorage } from '/@/utils/cache'
import { localeSetting } from '/@/settings/localeSetting'

const ls = createLocalStorage()

const lsLocaleSetting = (ls.get(LOCALE_KEY) || localeSetting) as LocaleSetting

export const useLocaleStore = defineStore('app-locale', () => {
  // State
  const localInfo = ref<LocaleSetting>(lsLocaleSetting)

  // Getters
  const getShowPicker = computed(() => !!localInfo.value?.showPicker)
  const getLocale = computed<LocaleType>(() => localInfo.value?.locale ?? 'zh_CN')

  // Actions
  /**
   * Set up multilingual information and cache
   * @param info multilingual info
   */
  function setLocaleInfo(info: Partial<LocaleSetting>) {
    localInfo.value = { ...localInfo.value, ...info }
    ls.set(LOCALE_KEY, localInfo.value)
  }

  /**
   * Initialize multilingual information and load the existing configuration from the local cache
   */
  function initLocale() {
    setLocaleInfo({
      ...localeSetting,
      ...localInfo.value,
    })
  }

  return {
    localInfo,
    getShowPicker,
    getLocale,
    setLocaleInfo,
    initLocale,
  }
})

// Need to be used outside the setup
export function useLocaleStoreWithOut() {
  return useLocaleStore(store)
}
